// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QlN7wqvZg73CEw {
  position: relative;
  flex-grow: 1;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 10px;
  border-radius: 6px;
  color: var(--ds-icon, #44546f);
}
.QlN7wqvZg73CEw.TuVfby8yC1q29N {
  background-color: var(--ds-background-selected, #e9f2ff);
  color: var(--ds-icon-selected, #0c66e4);
}
.QlN7wqvZg73CEw.TuVfby8yC1q29N:hover {
  background-color: var(--ds-background-selected-hovered, #cce0ff);
}
.QlN7wqvZg73CEw.TuVfby8yC1q29N:active {
  background-color: var(--ds-background-selected-pressed, #85b8ff);
}
.QlN7wqvZg73CEw.boxcPFj1yyuXTL {
  background-color: var(--ds-background-brand-bold, #0c66e4);
  color: var(--ds-icon-inverse, #ffffff);
}
.QlN7wqvZg73CEw.boxcPFj1yyuXTL:hover {
  background-color: var(--ds-background-brand-bold-hovered, #0055cc);
}
.QlN7wqvZg73CEw.boxcPFj1yyuXTL:active {
  background-color: var(--ds-background-brand-bold-pressed, #09326c);
}
.QlN7wqvZg73CEw.hfFA55_qyVU9mP {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 6px 10px;
}
.mRz3s3DuHsc_wY {
  display: block;
  position: absolute;
  bottom: var(--ds-space-0, 0);
  width: 12px;
  height: 2px;
  margin: var(--ds-space-0, 0) auto;
  background-color: var(--ds-icon-selected, #0c66e4);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `QlN7wqvZg73CEw`,
	"selected": `TuVfby8yC1q29N`,
	"primary": `boxcPFj1yyuXTL`,
	"withLabel": `hfFA55_qyVU9mP`,
	"indicator": `mRz3s3DuHsc_wY`
};
export default ___CSS_LOADER_EXPORT___;
